import { useState } from "react";
import {
  close_icon,
  menu_mobile, logo,
} from "../../../pages/LandingPage/components/SvgIcon";
import { useNavigate } from "react-router-dom";
import { Button } from "../../Buttons";
import LoginHeaderContainer from "./LoginHeaderContainer";
import MobileCanvas from "./MobileCanvas";
const MobileNavbar = ({ children, mobileMenu, setmobileMenu }) => {
  const navigate = useNavigate();
  return (
    <div className="mobile-header">
      <div
        className={`menu-opration-header ${!mobileMenu ? "open-menu" : "close-menu"} !px-[16px]`}
      >
        <span
          onClick={(e) => { e.stopPropagation(); setmobileMenu(!mobileMenu) }}
          className={`mobile-menu`}
        >
          {menu_mobile}
        </span>
        <span className="mobile-logo" onClick={() => navigate("/")} role="link" alt="FastFin Logo">
          {logo}
        </span>
        <LoginHeaderContainer />
      </div>
      <MobileCanvas mobileMenu={mobileMenu} setmobileMenu={setmobileMenu} >
        {children}
      </MobileCanvas>
    </div>
  )
}
export default MobileNavbar;